import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";

import { useIntl } from "react-intl";

const Info = (advertiser) => {
  const intl = useIntl();

  return (
    <>
      <div className="row">
        <div className="col-12 col-lg-6 col-xl-6">
          <div className="roe-card-style">
            <div className="roe-card-header">{<IntlMessages id="Advertisers.Data" />}</div>
            <div className="roe-card-body">
              <div className="form-group row">
                <div className="col-4 ">
                  <IntlMessages id="Advertisers.name" />
                </div>
                <div className="col-8">{advertiser.name}</div>
              </div>
              <div className="form-group row">
                <div className="col-4 ">{/* <IntlMessages id="Advertisers.login" /> */}</div>
                <div className="col-8">{advertiser.description}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </> ///
  );
};

export default connect(null, {})(Info);
